'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OmalomaService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.destinationInfoFromBooking = destinationInfoFromBooking;
exports.headerInfoFromBooking = headerInfoFromBooking;

require('moment');

var _utils = require('../core/utils.js');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OmalomaService = exports.OmalomaService = function () {
  function OmalomaService($q, $rootScope, userService, customerService, localizationService) {
    var _this = this;

    _classCallCheck(this, OmalomaService);

    this.$q = $q;
    this.$rootScope = $rootScope;
    this.userService = userService;
    this.customerService = customerService;
    this.localizationService = localizationService; // For language parameter
    this.cache = {};

    this.$rootScope.$on('userDataChanged', function () {
      return _this.handleLoginStateChange('in');
    });
    this.$rootScope.$on('logout', function () {
      return _this.handleLoginStateChange('out');
    });
  }

  _createClass(OmalomaService, [{
    key: 'handleLoginStateChange',
    value: function handleLoginStateChange(state) {
      console.log('[OS] Login state change:', state);
      this.invalidateCache();
    }

    // Try getting a promise for _thing_ from cache.
    // If it isn't cached, run _fetchAndCache_, which is expected to put a promise
    // for the requested content (and possibly other content) in cache.
    // Then, return the promise.

  }, {
    key: 'tryCache',
    value: function tryCache(thing, bookingNumber, fetchAndCache) {
      if (!this.cache[thing]) {
        this.cache[thing] = {};
      }
      if (!this.cache[thing][bookingNumber]) {
        fetchAndCache();
      }
      if (!this.cache[thing][bookingNumber]) {
        // Still not in cache. Something went wrong with fetchAndCache.
        var error = "[OS] Provided fetchAndCache didn't populate (" + thing + ", " + bookingNumber + ").";
        console.error(error);
        return this.$q.reject(error);
      }
      return this.cache[thing][bookingNumber];
    }
  }, {
    key: 'cachePromise',
    value: function cachePromise(thing, bookingNumber, promise) {
      var _this2 = this;

      if (!this.cache[thing]) {
        this.cache[thing] = {};
      }

      var oldPromise = this.cache[thing][bookingNumber];
      var replacement = oldPromise ? this.$q.race([oldPromise, promise]) : promise;
      this.cache[thing][bookingNumber] = replacement;

      // Assume the newer request has more up-to-date data.
      // When it finishes, update the result.
      promise.then(function (result) {
        return _this2.cacheResult(thing, bookingNumber, result);
      }, function (error) {
        return _this2.cache[thing][bookingNumber] = _this2.$q.reject(error);
      });

      // console.log('[OS] Cached promise for', thing, bookingNumber);
    }
  }, {
    key: 'cacheResult',
    value: function cacheResult(thing, bookingNumber, result) {
      if (!this.cache[thing]) {
        this.cache[thing] = {};
      }

      this.cache[thing][bookingNumber] = this.$q.resolve(result);
      // console.log('[OS] Cached result for', thing, bookingNumber);
    }
  }, {
    key: 'invalidateCache',
    value: function invalidateCache() {
      console.log('[OS] Cache invalidated.');
      this.cache = {};
      this.triggerRefresh();
    }
  }, {
    key: 'triggerRefresh',
    value: function triggerRefresh() {
      console.log('[OS] Triggering refresh.');
      this.$rootScope.$emit('omaloma-refresh', {});
    }

    // Return true if there is a logged-in user and they are a customer.

  }, {
    key: 'isLoggedInAsCustomer',
    value: function isLoggedInAsCustomer() {
      return this.customerService.isLoggedInAsCustomer();
    }
  }, {
    key: 'isLoggedInAsNewCustomer',
    value: function isLoggedInAsNewCustomer() {
      return this.customerService.isLoggedInAsNewCustomer();
    }
  }, {
    key: 'isLoggedInAsSomeOtherUserType',
    value: function isLoggedInAsSomeOtherUserType() {
      return this.customerService.isLoggedInAsSomeOtherUserType();
    }
  }, {
    key: 'login',
    value: function login(connectionName, email, password) {
      return this.userService.login(email, password, connectionName);
    }
  }, {
    key: 'logout',
    value: function logout() {
      return this.userService.logout();
    }
  }, {
    key: 'getOfficeSiteParameters',
    value: function getOfficeSiteParameters(connectionName) {
      return this.customerService.getOfficeSiteParameters(connectionName);
    }
  }, {
    key: 'getCustomerInfo',
    value: function getCustomerInfo() {
      var _this3 = this;

      return this.getCustomerNumber().then(function (customerNumber) {
        return _this3.customerService.getCustomer(customerNumber);
      });
    }
  }, {
    key: 'sendCustomerContactFormEmail',
    value: function sendCustomerContactFormEmail(emailObject) {
      return this.customerService.sendEmail(emailObject);
    }
  }, {
    key: 'saveCustomerInfo',
    value: function saveCustomerInfo(info) {
      return this.customerService.insertCustomer(info);
    }
  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      return this.customerService.changeCustomerPassword(oldPassword, newPassword);
    }
  }, {
    key: 'sendAccountRecoveryMail',
    value: function sendAccountRecoveryMail(connectionName, email) {
      return this.customerService.sendCustomerAccountRecoveryMail(connectionName, email);
    }
  }, {
    key: 'recoverAccount',
    value: function recoverAccount(connectionName, email, token, newPassword) {
      return this.customerService.recoverCustomerAccountWithToken(connectionName, email, token, newPassword);
    }
  }, {
    key: 'updatePassenger',
    value: function updatePassenger(customerNumber, bookingNumber, passenger) {
      return this.customerService.updatePassenger(customerNumber, bookingNumber, passenger);
    }
  }, {
    key: 'getBookingList',
    value: function getBookingList() {
      var _this4 = this;

      return this.tryCache('BookingList', 0, function () {
        return _this4.fetchBookingList();
      });
    }
  }, {
    key: 'fetchBookingList',
    value: function fetchBookingList(endDateFrom, endDateTo) {
      var _this5 = this;

      endDateFrom = endDateFrom || null;
      endDateTo = endDateTo || null;
      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this5.customerService.getCustomerBookingList(customerNumber, endDateFrom, endDateTo, _this5.language());
      });

      // Caching
      this.cachePromise('BookingList', 0, promise);
      promise.then(function (list) {
        _.forEach(list, function (booking) {
          var number = booking.BookInfos.BookingNumber;
          // Note: Can't cache the full booking since not everything is included in the list.
          // Only fields known to be included in full should be added here.
          // Note 2: We can't cache these as promises since we don't know the numbers at that point.
          _this5.cacheResult('DestinationInfo', number, destinationInfoFromBooking(booking));
          _this5.cacheResult('HeaderInfo', number, headerInfoFromBooking(booking));
        });
      });

      return promise;
    }
  }, {
    key: 'getBookingMaxDates',
    value: function getBookingMaxDates(bookingNumber) {
      var _this6 = this;

      return this.$q(function (resolve) {
        _this6.tryCache('Booking', bookingNumber).then(function (booking) {
          var beginDate = moment(booking.Productlines.products[0].BeginDate);
          var endDate = moment(booking.Productlines.products[0].EndDate);

          // Get max begin and end date of all bookings
          _.each(booking.Productlines.products, function (productLine) {
            if (moment(productLine.BeginDate) < beginDate) beginDate = moment(productLine.BeginDate);
            if (moment(productLine.EndDate) > endDate) endDate = moment(productLine.EndDate);
          });

          beginDate = beginDate.format('YYYY-MM-DD');
          endDate = endDate.format('YYYY-MM-DD');

          resolve({ BeginDate: beginDate,
            EndDate: endDate });
        });
      });
    }
  }, {
    key: 'getBooking',
    value: function getBooking(bookingNumber) {
      var _this7 = this;

      return this.tryCache('Booking', bookingNumber, function () {
        return _this7.fetchBooking(bookingNumber);
      });
    }
  }, {
    key: 'fetchBooking',
    value: function fetchBooking(bookingNumber) {
      var _this8 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this8.customerService.getCustomerBooking(customerNumber, bookingNumber, _this8.language());
      });

      // Caching
      this.cachePromise('Booking', bookingNumber, promise);
      this.cachePromise('DestinationInfo', bookingNumber, promise.then(destinationInfoFromBooking));
      this.cachePromise('HeaderInfo', bookingNumber, promise.then(headerInfoFromBooking));
      this.cachePromise('ProductLines', bookingNumber, promise.then(function (booking) {
        return booking.Productlines.products;
      }));
      this.cachePromise('Passengers', bookingNumber, promise.then(function (booking) {
        return booking.Passengers;
      }));

      return promise;
    }

    // Alias. Remove when not needed.

  }, {
    key: 'getCustomerBooking',
    value: function getCustomerBooking(bookingNumber) {
      return this.getBooking(bookingNumber);
    }
  }, {
    key: 'getPassengers',
    value: function getPassengers(bookingNumber) {
      var _this9 = this;

      return this.tryCache('Passengers', bookingNumber, function () {
        return _this9.fetchBooking(bookingNumber);
      });
    }
  }, {
    key: 'getDestinationInfo',
    value: function getDestinationInfo(bookingNumber) {
      var _this10 = this;

      return this.tryCache('DestinationInfo', bookingNumber, function () {
        return _this10.fetchBooking(bookingNumber);
      });
    }
  }, {
    key: 'getPassengerFieldSettings',
    value: function getPassengerFieldSettings(bookingNumber) {
      return this.getDestinationInfo(bookingNumber).then(function (di) {
        return di.PassengerFieldSettings;
      });
    }
  }, {
    key: 'getHeaderInfo',
    value: function getHeaderInfo(bookingNumber) {
      var _this11 = this;

      return this.tryCache('HeaderInfo', bookingNumber, function () {
        return _this11.fetchBooking(bookingNumber);
      });
    }
  }, {
    key: 'getProductLines',
    value: function getProductLines(bookingNumber) {
      var _this12 = this;

      return this.tryCache('ProductLines', bookingNumber, function () {
        return _this12.fetchBooking(bookingNumber);
      });
    }
  }, {
    key: 'getAccommodations',
    value: function getAccommodations(bookingNumber) {
      return this.getProductLines(bookingNumber).then(function (lines) {
        return _.filter(lines, isAccommodation);
      });
    }
  }, {
    key: 'getSchedule',
    value: function getSchedule(bookingNumber) {
      return this.getBooking(bookingNumber).then(scheduleFromBooking);
    }
  }, {
    key: 'getBookedExtraServices',
    value: function getBookedExtraServices(bookingNumber) {
      return this.getCustomerReservableExtraServices(bookingNumber).then(function (result) {
        var linesByDestAndProd = result.Lookups.ExtraServiceProductLines;
        return _.flatMap(linesByDestAndProd, function (linesByProd) {
          return _.flatMap(linesByProd, combineExtraServiceLines);
        });
      });
    }

    // Return promise resolving to customer-reservable extra services and other
    // relevant information.

  }, {
    key: 'getCustomerReservableExtraServices',
    value: function getCustomerReservableExtraServices(bookingNumber) {
      var _this13 = this;

      return this.tryCache('CustomerReservableExtraServices', bookingNumber, function () {
        return _this13.fetchCustomerReservableExtraServices(bookingNumber);
      });
    }
  }, {
    key: 'fetchCustomerReservableExtraServices',
    value: function fetchCustomerReservableExtraServices(bookingNumber) {
      var _this14 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this14.customerService.getCustomerReservableExtraServices(customerNumber, bookingNumber, _this14.language());
      });

      // Caching
      this.cachePromise('CustomerReservableExtraServices', bookingNumber, promise);
      this.cachePromise('Passengers', bookingNumber, promise.then(function (x) {
        return x.Passengers;
      }));

      return promise;
    }

    // Same thing for area extra services

  }, {
    key: 'getCustomerAreaServices',
    value: function getCustomerAreaServices(bookingNumber) {
      var _this15 = this;

      return this.tryCache('CustomerAreaServices', bookingNumber, function () {
        return _this15.fetchCustomerAreaServices(bookingNumber);
      });
    }
  }, {
    key: 'fetchCustomerAreaServices',
    value: function fetchCustomerAreaServices(bookingNumber) {
      var _this16 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this16.customerService.getCustomerAreaServices(customerNumber, bookingNumber, _this16.language());
      });

      // Caching
      this.cachePromise('CustomerAreaServices', bookingNumber, promise);

      return promise;
    }
  }, {
    key: 'getCustomerReservableAreaServices',
    value: function getCustomerReservableAreaServices(bookingNumber, beginDate, endDate) {
      var _this17 = this;

      return this.tryCache('CustomerReservableAreaServices', bookingNumber, function () {
        return _this17.fetchCustomerReservableAreaServices(bookingNumber, beginDate, endDate);
      });
    }
  }, {
    key: 'fetchCustomerReservableAreaServices',
    value: function fetchCustomerReservableAreaServices(bookingNumber, beginDate, endDate) {
      var _this18 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this18.customerService.getCustomerReservableAreaServices(customerNumber, bookingNumber, _this18.language(), beginDate, endDate);
      });

      // Caching
      this.cachePromise('CustomerReservableAreaServices', bookingNumber, promise);

      return promise;
    }

    // Book specified product lines as extra services. Return promise resolving to
    // the result of the operation.
    // Invalidates caches.

  }, {
    key: 'bookCustomerExtraServices',
    value: function bookCustomerExtraServices(bookingNumber, productLines) {
      var _this19 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this19.customerService.bookCustomerExtraServices(customerNumber, bookingNumber, productLines);
      });
      promise.then(function () {
        return _this19.invalidateCache();
      });
      return promise;
    }
  }, {
    key: 'getBookingBalance',
    value: function getBookingBalance(bookingNumber) {
      var _this20 = this;

      return this.tryCache('BookingBalance', bookingNumber, function () {
        return _this20.fetchBookingBalance(bookingNumber);
      });
    }
  }, {
    key: 'getCustomerBookingBalance',
    value: function getCustomerBookingBalance(bookingNumber) {
      return this.getBookingBalance(bookingNumber);
    }
  }, {
    key: 'fetchBookingBalance',
    value: function fetchBookingBalance(bookingNumber) {
      var _this21 = this;

      var promise = this.getCustomerNumber().then(function (customerNumber) {
        return _this21.customerService.getCustomerBookingBalance(customerNumber, bookingNumber);
      });

      // Caching
      this.cachePromise('BookingBalance', bookingNumber, promise);

      return promise;
    }
  }, {
    key: 'getCustomerPaymentMethods',
    value: function getCustomerPaymentMethods(bookingNumber, amount) {
      var _this22 = this;

      return this.getCustomerNumber().then(function (customerNumber) {
        return _this22.customerService.getCustomerPaymentMethods(customerNumber, bookingNumber, amount);
      });
    }
  }, {
    key: 'getSessionId',
    value: function getSessionId(bookingNumber) {
      return this.customerService.winresCloudService.getUser().loginResult.SessionID;
    }
  }, {
    key: 'getBookingFiles',
    value: function getBookingFiles(bookingNumber) {
      return this.customerService.getBookingFiles(bookingNumber);
    }
  }, {
    key: 'getBookingLinks',
    value: function getBookingLinks(bookingNumber) {
      return this.customerService.getBookingLinks(bookingNumber);
    }
  }, {
    key: 'getCustomerBookingFiles',
    value: function getCustomerBookingFiles(bookingNumber) {
      return this.customerService.getCustomerBookingFiles(bookingNumber);
    }
  }, {
    key: 'getCustomerBookingFileTypes',
    value: function getCustomerBookingFileTypes() {
      return this.customerService.getCustomerBookingFileTypes();
    }
  }, {
    key: 'getDepartureDocuments',
    value: function getDepartureDocuments(destCode, beginDate, endDate) {
      return this.customerService.getDepartureDocuments(destCode, beginDate, endDate);
    }
  }, {
    key: 'payCustomerBooking',
    value: function payCustomerBooking(bookingNumber, paymentSettings) {
      var _this23 = this;

      return this.getCustomerNumber().then(function (customerNumber) {
        return _this23.customerService.payCustomerBooking(customerNumber, bookingNumber, paymentSettings, _this23.language());
      }).then(function (result) {
        if (result && result.RedirectData) {
          return result;
        } else {
          throw result;
        }
      }).then(function (result) {
        if (result.HtmlForm) {
          var form = $(result.RedirectData);
          $('body').append(form);
          form.submit();
        } else {
          window.location = result.RedirectData;
        }
        return true;
      });
    }

    // If returning from payment service, return payment ID.
    // Otherwise, return null.

  }, {
    key: 'returnedFromPaymentService',
    value: function returnedFromPaymentService() {
      return !!this.paymentID();
    }
  }, {
    key: 'paymentID',
    value: function paymentID() {
      var paymentID = (0, _utils.getParameter)('customerPaymentID');
      return paymentID || null;
    }
  }, {
    key: 'confirmPayment',
    value: function confirmPayment() {
      var _this24 = this;

      var paymentID = this.paymentID();
      var returnUrl = '' + window.location;

      return this.customerService.confirmCustomerPaymentByReturnUrl(returnUrl).then(function (result) {
        if (result.OriginalOkUrl) {
          console.log('[OS] Confirmed payment:', paymentID);

          // Unlike the one in other code, this URL is the real original and doesn't contain the ID.

          // Remove HOST
          var path = result.OriginalOkUrl.replace(/https?:\/\/[^\/]*/, '') || '/';

          console.log('[OS] Redirecting to:', path);
          window.location = path;
          _this24.invalidateCache();
          return true;
        } else {
          // Got some error
          throw result.Result;
        }
      });
    }
  }, {
    key: 'isCustomerUploadInUse',
    value: function isCustomerUploadInUse() {
      return this.customerService.isCustomerUploadInUse();
    }
  }, {
    key: 'loadPrivateCustomerBookingFile',
    value: function loadPrivateCustomerBookingFile(file) {
      return this.customerService.loadPrivateCustomerBookingFile(file);
    }
  }, {
    key: 'uploadPrivateCustomerBookingFile',
    value: function uploadPrivateCustomerBookingFile(bookingNumber, file, overwrite) {
      return this.customerService.uploadPrivateCustomerBookingFile(bookingNumber, file, overwrite);
    }

    // Utilities

    // Return a promise resolving to the logged-in user's customer number.
    // If there is no logged-in user, wait until there is.

  }, {
    key: 'getCustomerNumber',
    value: function getCustomerNumber() {
      return this.customerService.getUserCustomerNumberWhenAvailable();
    }
  }, {
    key: 'connectionNameIfLoggedIn',
    value: function connectionNameIfLoggedIn() {
      return this.customerService.getConnectionNameIfLoggedIn();
    }
  }, {
    key: 'language',
    value: function language() {
      return this.localizationService.getLanguage();
    }
  }]);

  return OmalomaService;
}();

function destinationInfoFromBooking(booking) {
  var samples = sampleProducts(booking.Productlines.products);
  if (samples.length > 0) {
    return samples[0].DestinationInfo;
  } else {
    console.warn('[OS] Booking has no sample product lines:', booking);
    return null;
  }
}

function headerInfoFromBooking(booking) {
  return headerInfoFromProducts(booking.Productlines.products);
}

function scheduleFromBooking(booking) {
  if (!booking.Departures || booking.Departures.length == 0) {
    throw '[OS] departureInfoFromBooking: No departures.';
  }

  return _.map(booking.Departures, scheduleFromDeparture);
}

function scheduleFromDeparture(dep) {
  return [leg(dep.DeparturePlace, dep.ArrivalPlace, dep.DepartureVehicle, dep.DepartureDate, dep.DepartureTime, dep.ArrivalDate, dep.ArrivalTime), leg(dep.DeparturePlace2, dep.ArrivalPlace2, dep.ArrivalVehicle, dep.DepartureDate2, dep.DepartureTime2, dep.ArrivalDate2, dep.ArrivalTime2)];
}

function leg(from, to, vehicle, date1, time1, date2, time2) {
  return {
    from: from,
    to: to,
    vehicle: vehicle,
    begin: combineDateAndTime(date1, time1),
    end: combineDateAndTime(date2, time2)
  };
}

// Date is ISO 8601. Time is HH:MM.
function combineDateAndTime(date, time) {
  var cut = date.indexOf('T');
  if (cut !== -1) {
    date = date.substring(0, cut);
  }
  var dateTime = date + 'T' + time;
  // console.log('[OS] DateTime:', dateTime);
  return moment(dateTime).format('D.M.YYYY [klo] H.mm');
}

function headerInfoFromProducts(productLines) {
  var samples = sampleProducts(productLines);
  return headerInfoFromSampleProductLines(samples);
}

function headerInfoFromSampleProductLines(sampleProductLines) {

  var main = sampleProductLines[0];
  var image = _.find(_.map(sampleProductLines, function (p) {
    return p.DestinationInfo.Images[0];
  }));

  if (!main) {
    return null;
  }

  // Use ProductName (Vtuote.TUOTENIMI) if the main product is XINFO.
  var subtitle = main.DestinationInfo.ProductType == 'IF' ? main.DestinationInfo.ProductName : main.DestinationInfo.DestinationName;

  return {
    Headline: main.DestinationInfo.Headline,
    Subtitle: subtitle,
    BeginDate: main.BeginDate,
    EndDate: main.EndDate,
    BeginTime: main.BeginTime,
    EndTime: main.EndTime,
    Image: image
  };
}

function sampleProducts(products) {
  var xinfos = [];
  var passengerCounts = [];
  var rooms = [];
  var cabins = [];
  var fallbacks = [];

  _.forEach(products, function (product) {
    var di = product.DestinationInfo;

    if (di.ProductType == 'IF') {
      xinfos.push(product);
    } else if (di.ProductCode[0] == 'X' || di.DestinationCode[0] == 'X') {
      // Ignore product.
      // Note that this condition must be after the XINFO check
      // since XINFO products can and do start with X.
      return;
    } else if (di.ProductCode == '0MAT' || di.ProductCode == '1MAT') {
      passengerCounts.push(product);
    } else if (di.ProductType == 'HU' || di.ProductType == 'MÖ' || di.ProductType == 'MA') {
      rooms.push(product);
    } else if (di.ProductType == 'HY') {
      cabins.push(product);
    } else {
      fallbacks.push(product);
    }
  });

  var priorityList = _.concat(xinfos, passengerCounts, rooms, cabins, fallbacks);

  return priorityList;
}

function isAccommodation(product) {
  return product.DestinationInfo.Accommodation;
}

function combineExtraServiceLines(lines) {
  if (lines.length === 0) return [];
  var byDates = _.groupBy(lines, function (line) {
    return line.BeginDate + ' - ' + line.EndDate;
  });
  return _.flatMap(byDates, function (lines) {
    return {
      DestinationCode: lines[0].DestinationCode,
      ProductCode: lines[0].ProductCode,
      BeginDate: lines[0].BeginDate,
      EndDate: lines[0].EndDate,
      Capacity: _.sumBy(lines, function (line) {
        return line.Capacity;
      }),
      Price: _.sumBy(lines, function (line) {
        return line.Price;
      }),
      PriceQuantities: _.reduce(_.map(lines, function (line) {
        return line.PriceQuantities;
      }), combinePriceQuantityLists),
      Passengers: _.reduce(_.map(lines, function (line) {
        return line.Passengers;
      }), combinePassengerLists),
      LinkingInfo: lines[0].LinkingInfo
    };
  });
}

function combinePriceQuantityLists(listA, listB) {
  return _.zipWith(listA, listB, combinePriceQuantities);
}

function combinePriceQuantities(a, b) {
  return {
    Header: a.Header,
    Price: a.Price,
    Quantity: a.Quantity + b.Quantity
  };
}

function combinePassengerLists(listA, listB) {
  return _.zipWith(listA, listB, function (a, b) {
    return a || b;
  });
}

OmalomaService.$inject = ['$q', '$rootScope', 'userService', 'customerService', 'localizationService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/omalomaService.js
// module id = 326
// module chunks = 2